// extracted by mini-css-extract-plugin
export default {"formHeading":"aK-z","form":"bK-z","submitBtn":"cK-z","disabled":"dK-z","input":"eK-z","error":"fK-z","submitMsg":"gK-z","signIn":"hK-z"};